var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectCostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.047,
    height: 68.046,
    viewBox: "0 0 68.047 68.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M23.017,248.242a1.135,1.135,0,0,0,1.6,0l5.67-5.67-1.6-1.6-4.869,4.869L2.74,224.758l12.807-12.807-1.6-1.6L.335,223.956a1.135,1.135,0,0,0,0,1.6Zm0,0",
    transform: "translate(-0.002 -180.524)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M282.893,23.7,280.625,3.284a1.135,1.135,0,0,0-1-1L259.209.013a1.146,1.146,0,0,0-.926.326l-7.939,7.939,1.6,1.6L259.5,2.327l18.977,2.107,2.107,18.971-4.45,4.451-2.155-14.5a3.418,3.418,0,1,0-2.28.086l1.754,11.794L257.618,9.411a1.134,1.134,0,0,0-1.6,0l-5.67,5.67,1.6,1.6,4.869-4.869L271.09,26.09l-2.6,2.6,1.6,1.6,3.4-3.4a1.1,1.1,0,0,0,.161-.241l.476,3.2-2.241,2.241,1.6,1.6,1.052-1.053.72,4.834a3.831,3.831,0,1,0,7.554-1.242l-2.087-9.779,1.833-1.832a1.134,1.134,0,0,0,.326-.926Zm-10.2-14.619a1.134,1.134,0,1,1-1.134,1.134A1.134,1.134,0,0,1,272.693,9.079ZM280.6,36.7a1.563,1.563,0,1,1-3.087.474l-.965-6.522,2.281-2.281Zm0,0",
    transform: "translate(-214.854 -0.002)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M58.352,266.523l7.371-7.371,1.6,1.6-7.371,7.371Zm0,0",
    transform: "translate(-50.079 -222.411)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M83.137,291.32l7.371-7.371,1.6,1.6-7.372,7.371Zm0,0",
    transform: "translate(-71.351 -243.692)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M107.941,334.653l4.309-4.309,1.6,1.6-4.31,4.309Zm0,0",
    transform: "translate(-92.639 -283.51)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M132.742,367.008l3.063-3.062,1.6,1.6-3.062,3.063Zm0,0",
    transform: "translate(-113.924 -312.349)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M157.543,396.62l2.268-2.268,1.6,1.6-2.268,2.268Zm0,0",
    transform: "translate(-135.209 -338.444)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M178.131,220.51a18.029,18.029,0,0,0,10.729-3.545l8.179,8.179a3.54,3.54,0,0,0,5.006-5.006l-8.368-8.368-.145.145a18.127,18.127,0,1,0-15.4,8.6Zm22.31,1.232a1.272,1.272,0,1,1-1.8,1.8l-8.036-8.035a18.271,18.271,0,0,0,1.723-1.874Zm-22.31-35.254a15.877,15.877,0,1,1-15.877,15.877,15.877,15.877,0,0,1,15.877-15.877Zm0,0",
    transform: "translate(-137.303 -158.131)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M205.609,243.222A13.609,13.609,0,1,0,192,229.613,13.609,13.609,0,0,0,205.609,243.222Zm0-24.95a11.341,11.341,0,1,1-11.341,11.341A11.341,11.341,0,0,1,205.609,218.272Zm0,0",
    transform: "translate(-164.782 -185.38)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M261.67,261.613H259.4a1.134,1.134,0,0,1-1.134-1.134H256a3.4,3.4,0,0,0,3.4,3.4v2.268h2.268v-2.268a3.4,3.4,0,0,0,3.4-3.4v-1.134a3.4,3.4,0,0,0-3.4-3.4H259.4a1.134,1.134,0,0,1-1.134-1.134v-1.134a1.134,1.134,0,0,1,1.134-1.134h2.268a1.134,1.134,0,0,1,1.134,1.134h2.268a3.4,3.4,0,0,0-3.4-3.4V248H259.4v2.268a3.4,3.4,0,0,0-3.4,3.4v1.134a3.4,3.4,0,0,0,3.4,3.4h2.268a1.134,1.134,0,0,1,1.134,1.134v1.134A1.134,1.134,0,0,1,261.67,261.613Zm0,0",
    transform: "translate(-219.709 -212.843)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M5.671,27.222h7.576l7.642,5.458a1.13,1.13,0,0,0,.659.212,1.146,1.146,0,0,0,.616-.182,1.133,1.133,0,0,0,.5-1.18L21.8,27.222h6.555a5.678,5.678,0,0,0,5.67-5.67V5.675A5.677,5.677,0,0,0,28.352,0H5.671A5.677,5.677,0,0,0,0,5.675V21.552a5.678,5.678,0,0,0,5.67,5.67ZM2.268,5.675a3.4,3.4,0,0,1,3.4-3.4H28.352a3.4,3.4,0,0,1,3.4,3.4V21.552a3.4,3.4,0,0,1-3.4,3.4H20.414A1.133,1.133,0,0,0,19.3,26.315l.567,2.859-5.6-4a1.126,1.126,0,0,0-.656-.217H5.671a3.4,3.4,0,0,1-3.4-3.4Zm0,0",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M33.134,57.016H56.95V54.747H34.268V51.723L36.536,48.7l2.5,3.326a1.207,1.207,0,0,0,.938.454,1.134,1.134,0,0,0,.913-.505l3.694-5.541,4.7,5.639a1.142,1.142,0,0,0,.872.407.861.861,0,0,0,.107,0,1.134,1.134,0,0,0,.884-.579l5.67-10.207-1.982-1.1-4.868,8.76-4.61-5.535a1.114,1.114,0,0,0-.934-.413,1.135,1.135,0,0,0-.882.5l-3.647,5.473-2.441-3.255a1.174,1.174,0,0,0-1.814,0l-1.361,1.815V40H32V55.881a1.134,1.134,0,0,0,1.134,1.134Zm0,0",
    transform: "translate(-27.464 -34.33)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCostIcon);
export default __webpack_public_path__ + "static/media/projectCost_icon.ffb38f5b2370927670c7b599bcda2bd6.svg";
export { ForwardRef as ReactComponent };